import { BaseGrid, BaseGridItem, } from '@awaze/design-system.components.base-grid';
import { Button } from '@awaze/design-system.components.button';
import { Divider } from '@awaze/design-system.components.divider';
import { Text } from '@awaze/design-system.components.text';
import { breakpoints, pxToRems } from '@awaze/design-system.utils.react';
import styled, { css } from 'styled-components';
import { onDesktop, onMobile } from './search-form-composition.styles';
export const StyledNavWrapperDiv = styled.div `
  padding: ${pxToRems(12)} 0 ${pxToRems(8)} 0;
  display: flex;
  align-items: center;

  ${onDesktop} {
    padding: ${pxToRems(3)} 0 ${pxToRems(8)};
  }
`;
export const StyledPagingWrapperDiv = styled.div `
  display: flex;
  align-items: center;
  margin-left: auto;
`;
export const StyledPagingWrapperPopularDiv = styled(StyledPagingWrapperDiv) `
  padding: ${pxToRems(32)} 0 ${pxToRems(8)} 0;

  ${onDesktop} {
    padding: 0 0 ${pxToRems(12)};
  }
`;
export const StyledDestinationListWrapper = styled.div `
  ${onMobile} {
    padding-bottom: 480px;
  }
`;
export const StyledBaseGrid = styled(BaseGrid) `
  margin: 0;
`;
export const StyledBaseGridItem = styled(BaseGridItem) `
  padding-left: 0;
  border-bottom: 1px solid ${({ theme }) => theme.ColorGrey100};

  &:nth-child(1) {
    border-top: 1px solid ${({ theme }) => theme.ColorGrey100};
  }

  ${onDesktop} {
    padding: ${pxToRems(4)} ${pxToRems(8)} ${pxToRems(4)} 0;
    margin-left: 0;
    margin-right: 0;
    border-bottom: none;

    &:nth-child(1) {
      border-top: none;
    }

    &:nth-child(2n) {
      padding-right: 0;
    }

    @media screen and (min-width: ${breakpoints[1]}px) {
      &:nth-child(2n) {
        padding-right: ${pxToRems(8)};
      }

      &:nth-child(4n) {
        padding-right: 0;
      }
    }
  }
`;
export const StyledButton = styled(Button) `
  padding-left: ${pxToRems(8)};
  padding-bottom: ${pxToRems(8)};
  text-align: left;
  height: 100%;
  appearance: none;

  > p {
    display: inline-flex;
    justify-content: center;
    align-items: center;
    gap: 0.5rem;
  }

  ${onDesktop} {
    padding-left: ${pxToRems(10)};
  }

  &[data-testid='destination-list-popular-button'] {
    ${onDesktop} {
      padding: ${pxToRems(4)} 0 ${pxToRems(4)} ${pxToRems(10)};
    }
  }
`;
export const StyledNearbyButton = styled(StyledButton) `
  display: none;

  ${onDesktop} {
    display: inline-flex;
  }
`;
export const navigationButtons = css `
  color: ${({ theme }) => theme.ColorGrey800};
  font-weight: ${({ theme }) => theme.FontTextText200MidFontWeight};

  svg {
    width: ${pxToRems(16)};

    path {
      fill: ${({ theme }) => theme.ColorGrey800};
    }
  }
`;
export const StyledButtonBack = styled(Button) `
  padding: ${pxToRems(4)} 0 0;
  ${navigationButtons}
`;
export const StyledButtonPagination = styled(Button) `
  gap: ${pxToRems(5)};
  padding: 0 ${pxToRems(6)} 0 0;

  &[data-testid='destination-list-next-button'] {
    padding: 0 0 0 ${pxToRems(6)};
  }

  ${navigationButtons}
`;
export const StyledDivider = styled(Divider) `
  display: none;

  ${onDesktop} {
    display: block;
  }
`;
export const StyledDividerVert = styled(Divider) `
  height: ${pxToRems(16)};
  margin: 0 ${pxToRems(12)} 0;

  ${onDesktop} {
    margin-top: ${pxToRems(3)};
  }
`;
export const StyledTextLoading = styled(Text) `
  margin-top: ${pxToRems(15)};

  ${onDesktop} {
    margin: ${pxToRems(6)} 0 ${pxToRems(4)};
  }
`;
//# sourceMappingURL=destination-list.styles.js.map